const $inject = ['$scope', '$routeParams', 'dataService', '$timeout'];

const lbaBooleanCtrl = function ($scope, $routeParams, dataService, $timeout) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  $scope.$watchCollection('vm.data', function (newData, oldData) {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
    hideShowProperties(newData);
  });

  $timeout(() => hideShowProperties(vm.data),150);
  function hideShowProperties(val){
    if(!vm.settings.hideShowProperty) return;
        let classKey = "." + vm.settings.hideShowProperty;
        let className = classKey;
        if(val){
          $(className).show();
        }else{
          $(className).hide();
        }
  }
};

lbaBooleanCtrl.$inject = $inject;

export default lbaBooleanCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaBoolean/lbaBooleanCtrl.js